import { useTranslation, Trans } from "react-i18next";

import { Dialog } from 'primereact/dialog';

import Gallery from "../../../../../components/gallery/gallery.js";

import meltextureguesser1 from "../../../../../../assets/melTextureGuesser1.png";
import meltextureguesser2 from "../../../../../../assets/melTextureGuesser2.png";

export default function MelTextureGuesser({visible, setVisible}) {

    const { t } = useTranslation();

    return(
        <Dialog header="Mel Texture Guesser" visible={visible} style={{ width: '50vw' }} onHide={() => {if (!visible) return; setVisible(false); }} className="melTextureGuesserPanel">
            <Trans i18nKey="melTextureGuesserDetails" />

            <h2 className="text-center titles text-green-700">{t("technologies")}</h2>

            <p className="text-center">Python</p>

            <h2 className="text-center titles text-green-700">{t("pictures")}</h2>

            <Gallery images={[meltextureguesser1,meltextureguesser2]}/>
        </Dialog>
    )
}